module.exports = __webpack_public_path__ + "static/media/value-proposition-free@3x.78ecf11c.png";